// extracted by mini-css-extract-plugin
export default {"activeSVG":"export_activeSVG__eTFgM","inactiveSVG":"export_inactiveSVG__ZGcHe"};